import React from 'react'

function RadiologyLabReports() {
  return (
    <div>Radiology & Lab Reports  (daily, doctor-wise, pending)</div>
  )
}

export default RadiologyLabReports